import { Component, OnInit, Renderer2, ChangeDetectorRef, AfterContentInit } from '@angular/core';
import { DeviceFormatHelperService } from '../services/device-format-helper.service';
import { AdvancedSearchStore } from '../services/advanced-search/advanced-search.store';
import { AdvancedSearchService } from '../services/advanced-search/advanced-search.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/user-services/auth.service';
import { NgxValidators } from 'src/app/models/Helpers/ngxValidators';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: []
})
export class SearchComponent implements OnInit {

  width: number;
  height: number;
  isAdvancedResearchActive = false;
  isMobile = false;
  advancedSearchActiveClass = 'advanced-search-active';
  filteredOptions: Observable<string[]>;
  // myControl = new FormControl();
  options: string[];
  reactiveForm: FormGroup;
  isGuest = false;

  constructor(
    private renderer: Renderer2,
    private deviceFormatService: DeviceFormatHelperService,
    public searchStore: AdvancedSearchStore,
    private searchService: AdvancedSearchService,
    private router: Router,
    private userService: AuthService
    ) {
    }

  ngOnInit(): void {
    this.deviceFormatCheck();

    this.reactiveForm = new FormGroup({
      isin: new FormControl('')
    });

    if (!this.searchStore.autocompleteValues) {
      this.searchService.getIsinList()
      .then(() => {
        this.reactiveForm.get('isin').setValidators(NgxValidators.isinExists(Object.keys(this.searchStore?.autocompleteValues)));
        this.listenToUserInput();
      });
    } else {
      this.listenToUserInput();
      this.reactiveForm.get('isin').setValidators(NgxValidators.isinExists(Object.keys(this.searchStore?.autocompleteValues)));
    }

    this.router.onSameUrlNavigation = 'reload';
  }

  deviceFormatCheck() {
    if (document.body.classList.contains(this.deviceFormatService.mobileFormatClassName)) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  // onResized(event: ResizedEvent) {
  //   this.width = event.newWidth;
  //   this.height = event.newHeight;
  // }

  toggleSearch() {
    // console.log('toggle search');
    if (!document.body.classList.contains(this.advancedSearchActiveClass)) {
      this.renderer.addClass(document.body, this.advancedSearchActiveClass);
    } else {
      this.renderer.removeClass(document.body, this.advancedSearchActiveClass);
    }
  }

  listenToUserInput() {
    this.filteredOptions = this.reactiveForm.get('isin').valueChanges
      .pipe(
        startWith(''),
        map(isin => isin?.length >= 1 ? this.search(isin) : this.options = [])
      );
  }
  search(isin: string): string[] {
    const filterValue = isin.toLowerCase().replace(/\s+/g, '');
    this.options = Object.keys(this.searchStore.autocompleteValues)
      .filter(option => option.toLowerCase().includes(filterValue))
      .slice(0, 20);
    return this.options;
  }
  displayFn(record: string): string {
    return record ? record : '';
  }

  goToDetaglioIsin() {
    let isin = this.reactiveForm.get('isin').value;
    // console.log(isin);
    this.userService.userManager.getUser().then(
      user => {
        this.isGuest = user?.profile?.role === 'CedLabGuest' ? true : false;
        if (this.isGuest) {
        isin = 'XS0993403558';
      }
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/menu/scheda-certificato'], { queryParams: { isin} });
    }
    );

  }

}
